import { t } from '../../lib/assert'
import { l } from '../../lib/imports'
import { common } from '../../main/common-sidecar'
import { voyageJsonServerInterface } from './voyageJsonServerInterface-sidecar'
import { voyageTileData } from './voyageTileData-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageTilemapPart } from './voyageTilemapPart-sidecar'

let _isDirty = false
let _saveDelay = 0
let _isLoaded = false
export function trySave() {
  if (_isDirty) {
    let dt = common.getUpdateDelta()
    _saveDelay += dt
    if (_saveDelay > 1) {
      doSave()
      _isDirty = false
    }
  }
}
export function setDirty() {
  _isDirty = true
  _saveDelay = 0
}
export function getIsLoaded() {
  return _isLoaded
}

function doSave() {
  let tiles = getTilesData()

  voyageJsonServerInterface.save({ tiles })
}

function getTilesData() {
  let tm = voyageTilemap.get()
  let tiles = {
    w: tm.width,
    h: tm.height,
    v: 1,
    t: [] as any[],
  }

  l.forEach(tm.parts, (c) => {
    tiles.t.push(
      ...[
        c.tile1.type,
        c.subTileIdx1,
        c.colorIdx1,
        c.tile2.type,
        c.subTileIdx2,
        c.colorIdx2,
        c.tile3.type,
        c.subTileIdx3,
        c.colorIdx3,
      ],
    )
    if (c.tile3.includesText) {
      tiles.t.push(c.text3)
    }
  })

  return tiles
}

export function load() {
  _isLoaded = false
  voyageJsonServerInterface.loadAsync().then((data) => {
    if (data && data.tiles) {
      console.log('loaded', data.tiles.w, data.tiles.h)
      let tData = data.tiles.t

      let tm = voyageTilemap.get()
      let idx = 0
      for (let j = 0; j < tm.height; j++) {
        for (let i = 0; i < tm.width; i++) {
          let t = voyageTilemap.getUnsafe(i, j)

          voyageTilemapPart.setTile(
            t,
            voyageTileData.get(tData[idx]),
            tData[idx + 1],
            tData[idx + 2],
          )
          idx += 3

          voyageTilemapPart.setTile(
            t,
            voyageTileData.get(tData[idx]),
            tData[idx + 1],
            tData[idx + 2],
          )
          idx += 3

          voyageTilemapPart.setTile(
            t,
            voyageTileData.get(tData[idx]),
            tData[idx + 1],
            tData[idx + 2],
          )
          idx += 3

          if (t.tile3.includesText) {
            voyageTilemapPart.setText(t, '' + tData[idx])
            idx++
          }
        }
      }
    }

    _isLoaded = true
  })
}
